module.exports = __webpack_public_path__ + "img/pick4_g.189e32a5.png";